import Vue from 'vue'

// eslint-disable-next-line
const Verte = require('verte').default
import 'verte/dist/verte.css'

Vue.component('verte', Verte)
